import React from 'react';
import NewBaseTable from 'components/NewBaseTable/NewBaseTable';
import { OrderTableWrapper } from './NewSFOrdersTableStyled';
import { PartQuote } from 'types';
import { generateQuotesColumnConfigs } from './OrderUtility';
import Pagination from 'components/Pagination';
import { ITEMS_PER_PAGE } from '.';
interface Props {
  orderQuotes: PartQuote[];
  formatPODate: (date: string) => string;
  t: (key: string) => string;
  isDataFetching: boolean;
  showQuoteModal: (quote: PartQuote) => void;
  setCurrentPage: (page: number) => void;
  totalRecords: number;
  currentPage: number;
}
const defaultSortState = {
  id: 'startTime',
  desc: true
};
const QuoteRequest = ({
  orderQuotes,
  formatPODate,
  t,
  isDataFetching,
  showQuoteModal,
  setCurrentPage,
  totalRecords,
  currentPage
}: Props): JSX.Element => {
  return (
    <>
      <OrderTableWrapper>
        <NewBaseTable
          newTableData={orderQuotes as PartQuote[]}
          columnConfigs={generateQuotesColumnConfigs({
            formatPODate,
            t,
            showQuoteModal
          })}
          sortState={defaultSortState}
          enableFilter={false}
          isShowGlobalSearch={false}
          isShowColumnOptions={true}
          isDataLoading={isDataFetching}
          tdMarginLeft="0.625rem"
          textAlign="left"
        />
      </OrderTableWrapper>
      {orderQuotes && orderQuotes.length > 0 && (
        <Pagination
          onPageChange={(page) => setCurrentPage(page)}
          itemsPerPage={ITEMS_PER_PAGE}
          numItems={totalRecords}
          currentPage={currentPage}
        />
      )}
    </>
  );
};
export default QuoteRequest;
